const { GkifyThemeStyles, GkifyThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new GkifyTheme.Modal();
    this.isOpen = false;

    addEventDelegate({
      selector: '.g-product-quickview-button',
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        this.number = this.getScrollToTop();
        if (productHandle) this.fetchHtml(productHandle);
      },
    });

    window.GkifyEvents.subscribe(GkifyTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) GkifyTheme.ProductQuickView.close();
    });
  }
  getScrollToTop() {
    let scrollDom = null;
    if (GkifyTheme.config.mqlMobile) {
      scrollDom = document.querySelector('.g-modal--content');
    } else {
      scrollDom = document.querySelector('.g-product-quickview--info');
    }
    return scrollDom && scrollDom.scrollTop;
  }
  scrollToTop() {
    let scrollDom = null;
    if (GkifyTheme.config.mqlMobile) {
      scrollDom = document.querySelector('.g-modal--content');
    } else {
      scrollDom = document.querySelector('.g-product-quickview--info');
    }
    scrollDom && (scrollDom.scrollTop = this.number || 0);
  }
  fetchHtml(productHandle) {
    loadAssetsNew([GkifyThemeStyles.product, GkifyThemeStyles.productInventory], 'quick-view-assets');
    fetchSection('product-quickview', { url: `${window.GkifySettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector('.g-product-quickview');
        const firstModel = html.querySelector('product-model');
        this.mediaGallery = this.modalContent.querySelector('media-gallery');
        loadPaypalScript();
        loadAssetsNew(
          [GkifyThemeScripts.productMedia, GkifyThemeScripts.variantsPickerCompose, GkifyThemeScripts.productInventory],
          'variants-picker',
          () => {
            const colorScheme = this.modalContent.dataset.colorScheme;
            this.modal.removeChild(this.modal.firstChild);
            this.modal.appendChild(this.modalContent);
            this.modal.setWidth('960px');
            this.modal.open();
            this.modal.setSizes(`g-gradient ${colorScheme}`);
            this.toggleLoading(this.target, false);
            this.isOpen = true;
            this.scrollToTop();
          }
        );
        if (firstModel) {
          loadAssetsNew(
            [
              GkifyThemeScripts.productModel,
              'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css',
            ],
            'product-model-assets'
          );
        }
      })
      .catch(console.error);
  }

  close(e) {
    this.modal.close(e);
    this.isOpen = false;
  }

  toggleLoading(target, loading) {
    if (loading) {
      target.classList.add('g-spinner-loading');
    } else {
      target.classList.remove('g-spinner-loading');
    }
  }
}

GkifyTheme.ProductQuickView = new QuickView();

function loadPaypalScript() {
  try {
    const script = document.createElement('script');
    script.src = `${
      window.location.origin
    }/cdn/shopifycloud/portable-wallets/latest/portable-wallets.en.js?v=${Date.now()}`;
    script.type = 'module';
    script.defer = true;
    document.body.appendChild(script);
  } catch (error) {
    console.error(error);
  }
}
